export type SearchConfig = {
  host: string;
  search_key: string;
  products_index: string;
  pagination?: {
    max_total_hits: number;
    hits_per_page: number;
    max_pages: number;
  };
  instant_search?: {
    configure?: {
      hitsPerPage?: number;
    };
  };
};

type SearchConfigResponse = {
  data: SearchConfig;
};

export async function loadSearchConfig() {
  const { $api } = useNuxtApp();
  const response = await $api<SearchConfigResponse>('/search/config', {
    skipAuth: true,
  });

  if (
    !response?.data?.host ||
    !response.data.search_key ||
    !response.data.products_index
  ) {
    throw new Error('Search config unavailable');
  }

  return response.data;
}
